<template>
  <LibraryListItem>
    <DocumentScoreLink
      :id="document.id"
      :score="document.score_total_capped"
      :language-code="document.language_code"
      class="ml-5"
    />
    <PostTitleCompanyBadgesCell
      :title="document.title"
      :company="document.company"
      :is-external="document.is_external"
      :is-evergreen="document.is_evergreen"
      :language-code="document.language_code"
    />

    <div
      class="document-date"
      data-testid="revision-modified-date"
    >
      {{ document.unpublished_at ? new Date(document.unpublished_at).toLocaleDateString("en-US") : '' }}
    </div>
    <PostReqIdCell
      :req-uuid="document.req_uuid"
      :ats-req-id="document.ats_requisition_id"
      :flexible-id="document.flexible_id"
      @library-req-report-track="emits('library-req-report-track', document)"
    />
    <PostLocationCell :location="document.location" />
    <PostDepartmentCell
      v-if="integrated"
      :ats-department-name="document.ats_department_name"
    />
  </LibraryListItem>
</template>

<script setup>
import LibraryListItem from '@/components/shared/LibraryListItem.vue';
import PostTitleCompanyBadgesCell from '@/components/library/listItemCells/PostTitleCompanyBadgesCell.vue';
import PostReqIdCell from '@/components/library/listItemCells/PostReqIdCell.vue';
import PostLocationCell from '@/components/library/listItemCells/PostLocationCell.vue';
import PostDepartmentCell from '@/components/library/listItemCells/PostDepartmentCell.vue';
import DocumentScoreLink from '@/components/shared/DocumentScoreLink.vue';

defineProps({
  document: {
    type: Object,
    required: true,
  },
  integrated: {
    type: Boolean,
    required: true,
  },
});

const emits = defineEmits(['library-req-report-track']);
</script>

<style lang="less" scoped>

</style>
